import s from './styles.module.css';

const TextSkeleton = ({ width }: { width: number }) => (
  <span className={s.skeleton} qa-element="skeleton" style={{ width }} />
);

export default TextSkeleton;
